import cx from "classnames";

import type { NavVisibility } from "./types";

import styles from "./AppHeader.module.scss";

export const getVisibilityClasses = (visibility?: NavVisibility) => {
  if (!visibility) return "";

  return cx(
    visibility.phone ? styles["phone-flex"] : styles["phone-hidden"],
    visibility.tablet ? styles["tablet-flex"] : styles["tablet-hidden"],
    visibility.desktop ? styles["desktop-flex"] : styles["desktop-hidden"],
    visibility.large ? styles["large-flex"] : styles["large-hidden"]
  );
};
